/* unplugin-vue-components disabled */import { render } from "./HeaderTable.vue?vue&type=template&id=b379473a&scoped=true&ts=true"
import script from "./HeaderTable.vue?vue&type=script&lang=ts"
export * from "./HeaderTable.vue?vue&type=script&lang=ts"

import "./HeaderTable.vue?vue&type=style&index=0&id=b379473a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b379473a"]])

export default __exports__